import { z } from 'zod';

export const DataResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    additional: z.any().nullable().optional(),
    itemsPerPage: z.number().nullable().optional(),
    totalItems: z.number().nullable().optional(),
    message: z.string().nullable().optional(),
    ordering: z.string().nullable().optional(),
    pageNumber: z.number().nullable().optional(),
  });
